var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaborations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.95C0 1.43283 0.205446 0.936838 0.571142 0.571142C0.936838 0.205446 1.43283 0 1.95 0H11.05C11.5672 0 12.0632 0.205446 12.4289 0.571142C12.7946 0.936838 13 1.43283 13 1.95V8.45C13 8.96717 12.7946 9.46316 12.4289 9.82886C12.0632 10.1946 11.5672 10.4 11.05 10.4H3.46645L1.3 12.025C0.7644 12.4267 0 12.0445 0 11.375V1.95Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 5.85C3.72761 5.85 3.56228 5.91848 3.44038 6.04038C3.31848 6.16228 3.25 6.32761 3.25 6.5C3.25 6.67239 3.31848 6.83772 3.44038 6.95962C3.56228 7.08152 3.72761 7.15 3.9 7.15H5.85C6.02239 7.15 6.18772 7.08152 6.30962 6.95962C6.43152 6.83772 6.5 6.67239 6.5 6.5C6.5 6.32761 6.43152 6.16228 6.30962 6.04038C6.18772 5.91848 6.02239 5.85 5.85 5.85H3.9ZM3.25 3.9C3.25 3.72761 3.31848 3.56228 3.44038 3.44038C3.56228 3.31848 3.72761 3.25 3.9 3.25H9.1C9.27239 3.25 9.43772 3.31848 9.55962 3.44038C9.68152 3.56228 9.75 3.72761 9.75 3.9C9.75 4.07239 9.68152 4.23772 9.55962 4.35962C9.43772 4.48152 9.27239 4.55 9.1 4.55H3.9C3.72761 4.55 3.56228 4.48152 3.44038 4.35962C3.31848 4.23772 3.25 4.07239 3.25 3.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborations);
export default __webpack_public_path__ + "static/media/collaborations.d56305ef2f2ed0fc909a3fdda9e86c53.svg";
export { ForwardRef as ReactComponent };